import cx from 'classnames';
import { h } from 'preact';

function OtherCandidate({ isViewable, candidateCount, embedType, onClick }) {
  const classes = cx('candidate race__candidate-row', {
    'race__candidate-row--hidden': !isViewable,
  });

  return (
    <tr class={classes}>
      <td
        class="candidate__cell candidate__party t-align-center"
        onClick={onClick}
      >
        <svg class="icon icon-angle-down">
          <use xlinkHref="#icon-angle-down" />
        </svg>
      </td>
      <th class="candidate__cell candidate__name">
        <button class={embedType} onClick={onClick}>
          Show All ({candidateCount}){' '}
        </button>
      </th>
      <th class="candidate__cell candidate__votes"></th>
      <th class="candidate__cell candidate__pct"></th>
    </tr>
  );
}

export default OtherCandidate;
